export type announcementtype = {
    title: string
}

export function announcementlatest(): Promise<announcementtype[]> {
    let test: Promise<announcementtype[]> = Promise.resolve([
        { title: "ประกาศ 1: จัดซื้ออุปกรณ์คอมพิวเตอร์" },
        { title: "ประกาศ 2: จัดหาบริการดูแลระบบเครือข่าย" },
        { title: "ประกาศ 3: จัดจ้างทำความสะอาดสำนักงาน" },
        { title: "ประกาศ 4: จัดซื้อเครื่องพิมพ์" },
        { title: "ประกาศ 5: จัดหาบริการบำรุงรักษาเครื่องจักร" },
        { title: "ประกาศ 6: จัดซื้ออุปกรณ์คอมพิวเตอร์" },
        { title: "ประกาศ 7: จัดหาบริการดูแลระบบเครือข่าย" },
        { title: "ประกาศ 8: จัดจ้างทำความสะอาดสำนักงาน" },
        { title: "ประกาศ 9: จัดซื้อเครื่องพิมพ์" },
        { title: "ประกาศ 10: จัดหาบริการบำรุงรักษาเครื่องจักร" }
    ]);
    return test;
}